<template>
  <div id="basicinfo">
    <!-- 编辑用户时，用户信息加载失败 -->
    <div class="fail" v-if="isShowFail">当前用户信息加载失败，请重试！</div>
    <!-- ① :model校验指定校验xx对象中的属性, 指定xx对象以外的属性不生效 -->
    <el-form ref="userInfoRef" :model="userInfo" :rules="rules" label-width="95px" v-loading="isLoading" v-if="!isShowFail"
      style="margin-top: -40px" class="form-basicinfo">
      <div v-if="type === 'first'">
        <el-form-item label="账号">
          <el-input v-model="userInfo.userName" placeholder="请输入账号" clearable disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="所属角色">
          <el-select v-model="userInfo.rolesId" placeholder="请选择所属角色" clearable disabled="disabled" style="width: 100%">
            <el-option v-for="item in addTypeList" :label="item.value" :value="item.key" :key="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="userInfo.name" placeholder="请输入姓名(仅限中文)" clearable></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="tel">
          <el-input v-model="userInfo.tel" placeholder="请输入电话号码" clearable></el-input>
        </el-form-item>
      </div>
      <div v-if="type === 'second'">
        <el-form-item label="新密码" prop="passWord">
          <el-input v-model="userInfo.newpassWord" placeholder="请输入密码" clearable show-password validate-event></el-input>
          <p class="err-aux" v-show="isPswErrAux1">
            密码必须数字与字母结合 长度必须大于或等于8位
          </p>
        </el-form-item>
        <el-form-item label="确认新密码" prop="passWordConfirm">
          <el-input v-model="userInfo.newpassWordConfirm" placeholder="请再次输入密码" clearable show-password validate-event>
          </el-input>
          <p class="err-aux" v-show="isPswErrAux2">请再次输入密码</p>
          <p class="err-aux" v-show="isPswErrAux3">两次输入密码不一致</p>
        </el-form-item>
      </div>
    </el-form>
    <span class="btn-area">
      <el-button type="primary" @click="onSubmit('userInfoRef')">提交保存</el-button>
      <el-button @click="onCancel">取消</el-button>
    </span>
  </div>
</template>

<script>
// 引入logout方法
import { logOut } from "network/login.js";
import { editAdmin, SettingPasswordTo } from "network/administrator";
import { validateName, validateTel, letterNumber } from "common/utils";
export default {
  name: "BasicInfo",
  props: {
    userInfoData: Object,
    addTypeList: Array,
    type: {
      type: String,
      default: "first",
    },
  },
  data() {
    // 中文姓名
    var validateName = (rule, value, callback) => {
      if (!value) {
        this.activeName = "first";
        callback(new Error("名字不能为空"));
      } else if (!/[\u4e00-\u9fa5]{2,}$/.test(value)) {
        this.activeName = "first";
        callback(new Error("请填写中文姓名,并且大于2个字！"));
      } else {
        callback();
      }
    };
    return {
      activeName: "first",
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
          {
            validator: validateName,
            trigger: "blur",
          },
        ],
        tel: [
          {
            required: true,
            message: "请输入电话号码",
            trigger: "blur",
          },
          {
            validator: validateTel,
            trigger: "blur",
          },
        ],
      },
      userInfo: {},
      isLoading: false,
      isShowFail: false,
      isPswErrAux1: false,
      isPswErrAux2: false,
      isPswErrAux3: false,
      ischangeName: false, //判断是否改了名字false
      ischangeTel: false, //判断是否改了名字false
      oldInfo: {}, //拷贝一份管理员信息
      islogOut: false, //判断是否需要退出登录
    };
  },
  computed: {
    adminInfo() {
      if (
        (this.$store.state && this.$store.state.AdminCache) ||  sessionStorage.getItem("AdminCache") 
      ) {
        return this.$store.state.AdminCache || JSON.parse(sessionStorage.getItem("AdminCache"));
      }
      return null;
    },
  },
  watch: {
    "userInfo.name"(newval, oldval) {
      if (oldval) {
        if (newval == this.oldInfo.name) {
          this.ischangeName = false;
        } else {
          this.ischangeName = true;
        }
      }
    },
    "userInfo.tel"(newval, oldval) {
      if (oldval) {
        if (newval == this.oldInfo.tel) {
          this.ischangeTel = false;
        } else {
          this.ischangeTel = true;
        }
      }
    },
    "userInfo.newpassWord"(val) {
      if (val == "") {
        this.isPswErrAux1 = false;
      }
      if (letterNumber.test(val) == false && val.length > 0) {
        this.isPswErrAux1 = true;
      } else {
        this.isPswErrAux1 = false;
      }
    },
    "userInfo.newpassWordConfirm"(val) {
      if (val == "") {
        this.isPswErrAux2 = false;
        this.isPswErrAux3 = false;
      }
    },
    userInfoData() {
      return (this.activeName = "first");
    },
    activeName(val) {
      if (val == "second") {
        this.userInfo.newpassWord = "";
        this.userInfo.newpassWordConfirm = "";
        this.isPswErrAux1 = false;
        this.isPswErrAux2 = false;
        this.isPswErrAux3 = false;
      }
    },
  },
  created() {
    this.oldInfo = JSON.parse(JSON.stringify(this.userInfoData)); //深拷贝一份管理员信息
    this.activeName = "first";
    this.userInfo = this.userInfoData;
    // ②vue不会监听data中初始状态不存在的属性值变化，无法更新到视图中，可通过Vue.set(target,key,value)和this.$set(target,key,value)方式来新增或修改属性
    this.$set(this.userInfo, "newpassWordConfirm", "");
    this.$set(this.userInfo, "newpassWord", ""); //给数组内的对象添加一个新的元素
  },
  methods: {
    inputblur1() {
      if (
        this.userInfo.newpassWord.length !== 0 &&
        this.userInfo.newpassWordConfirm.length == 0
      ) {
        this.isPswErrAux1 = false;
        this.isPswErrAux2 = true;
        this.isPswErrAux3 = false;
      }
    },
    inputblur2() {
      if (
        this.userInfo.newpassWordConfirm.length > 0 &&
        this.userInfo.newpassWord !== this.userInfo.newpassWordConfirm
      ) {
        this.isPswErrAux1 = false;
        this.isPswErrAux2 = false;
        this.isPswErrAux3 = true;
      }
    },
    // 提交
    onSubmit(formName) {
      if (this.isLoading) {
        this.activeName = "first";
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.isLoading = false;
          // 当没有输入新密码，输入了确认密码时
          if (
            (this.userInfo.newpassWord.length == 0 &&
              letterNumber.test(this.userInfo.newpassWordConfirm) &&
              this.userInfo.newpassWordConfirm.length >= 8) ||
            (this.userInfo.newpassWord.length == 0 &&
              this.userInfo.newpassWordConfirm.length > 0)
          ) {
            this.isPswErrAux1 = true;
            this.isPswErrAux2 = false;
            this.isPswErrAux3 = false;
          }
          //  当输入了新密码没有输入确认密码
          if (
            this.userInfo.newpassWord.length >= 8 &&
            letterNumber.test(this.userInfo.newpassWord) &&
            this.userInfo.newpassWordConfirm.length == 0
          ) {
            this.isPswErrAux1 = false;
            this.isPswErrAux2 = true;
            this.isPswErrAux3 = false;
          }
          // 当两次密码不一样时
          if (
            this.userInfo.newpassWord.length >= 0 &&
            letterNumber.test(this.userInfo.newpassWord) &&
            this.userInfo.newpassWordConfirm.length > 0 &&
            this.userInfo.newpassWord !== this.userInfo.newpassWordConfirm
          ) {
            this.isPswErrAux1 = false;
            this.isPswErrAux2 = false;
            this.isPswErrAux3 = true;
          }
          // 当两次密码不一样时
          if (
            this.userInfo.newpassWord.length >= 0 &&
            this.userInfo.newpassWord.length < 8 &&
            letterNumber.test(this.userInfo.newpassWord)
          ) {
            this.isPswErrAux1 = true;
            this.isPswErrAux2 = false;
            this.isPswErrAux3 = false;
          }
          // 当修改了密码或者修改了姓名电话
          if (
            (this.userInfo.newpassWord == this.userInfo.newpassWordConfirm &&
              this.userInfo.newpassWord.length >= 8 &&
              this.userInfo.newpassWordConfirm.length >= 8) ||
            this.ischangeName == true ||
            (this.ischangeTel == true)
          ) {
            this.isPswErrAux1 = false;
            this.isPswErrAux2 = false;
            this.isPswErrAux3 = false;
            this.submitPost();
          }
          //  没有任何修改点击提交
          if (
            this.userInfo.newpassWord == this.userInfo.newpassWordConfirm &&
            this.userInfo.newpassWord.length == 0 &&
            this.userInfo.newpassWordConfirm.length == 0 &&
            this.ischangeName == false &&
            this.ischangeTel == false
          ) {
            this.islogOut = false;
            this.$emit("close-dialog");
          }
        }
      });
    },
    // 提交数据请求
    async submitPost() {
      this.userInfo.passWord = this.userInfo.newpassWord; //新密码
      this.userInfo.passWordConfirm = this.userInfo.newpassWordConfirm;
      this.userInfo.id = this.adminInfo.adminId
      if (
        letterNumber.test(this.userInfo.passWord) === false &&
        this.userInfo.passWord.length > 0
      ) {
        this.$message.warning("密码必须数字与字母结合  长度必须大于或等于8位");
        return false;
      }
      if (
        letterNumber.test(this.userInfo.passWordConfirm) === false &&
        this.userInfo.passWordConfirm.length > 0
      ) {
        this.$message.warning("密码必须数字与字母结合  长度必须大于或等于8位");
        return false;
      }
      if (this.type === 'first') {
        const result = await editAdmin(this.userInfo);
        if (result && result.code === 1) {
          this.isLoading = false;
          // 上面通过了新密码的校验，所以这里直接判断有无新密码 来执行重新登陆
          if (this.userInfo.passWord.length >= 8) {
            this.$alert("修改成功，请重新登录！");
            this.islogOut = true;
            var islogOutBoolean = this.islogOut;
            this.$emit("close-dialog", islogOutBoolean);
          } else {
            this.$alert(result.message);
            this.islogOut = false;
            var islogOutBoolean = this.islogOut;
            this.$emit("close-dialog", islogOutBoolean);
          }
        } else {
          this.isLoading = false;
          this.$alert(result.message, "提示", {
            confirmButtonText: "确定",
          });
        }
      } else {
        const res = await SettingPasswordTo(this.userInfo)
        if (res.code) {
          this.isLoading = false;
          // 上面通过了新密码的校验，所以这里直接判断有无新密码 来执行重新登陆
          if (this.userInfo.passWord.length >= 8) {
            this.$alert("修改成功，请重新登录！");
            this.islogOut = true;
            var islogOutBoolean = this.islogOut;
            this.$emit("close-dialog", islogOutBoolean);
          } else {
            this.$alert(result.message);
            this.islogOut = false;
            var islogOutBoolean = this.islogOut;
            this.$emit("close-dialog", islogOutBoolean);
          }
        } else {
          this.isLoading = false;
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
          });
        }
      }
    },
    // 取消
    onCancel() {
      this.$emit("close-dialog");
    },
    // // 密码输入格式校验
    // validatePsw () {
    //   const pswReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[a-zA-Z0-9]{8,20}$/;
    //   this.userInfo.newpassWord = this.userInfo.newpassWord.replace(pswReg, "");
    //   this.userInfo.newpassWordConfirm = this.userInfo.newpassWordConfirm.replace(pswReg, "");
    // },
  },
};
</script>

<style scoped>
.form-basicinfo {
  margin-bottom: 15px;
}

.el-form-item {
  margin-bottom: 24px !important;
}

.btn-area {
  display: block;
  margin-bottom: -5px;
  padding-left: 95px;
}

.fail {
  text-align: center;
  color: #959595;
}

#basicinfo>>>.el-tabs .el-tabs__item {
  background-color: #fff !important;
}

#basicinfo>>>.el-tabs__content {
  margin-top: 20px;
}

.err-aux {
  padding-top: 2px;
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}
</style>